import './index-f674799c.js';
import { toRefs, ref, computed, onMounted, resolveComponent, resolveDirective, openBlock, createElementBlock, normalizeClass, createElementVNode, withDirectives, vModelCheckbox, createVNode, createCommentVNode, vShow, toDisplayString } from 'vue';
import { useField } from 'vee-validate';
import { u as useToggler } from './useToggler-e9ff86c0.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faQuestionCircle);
var script = {
  name: "form-control-checkbox",
  props: {
    name: {
      required: true,
      type: String
    },
    code: {
      required: false,
      type: String,
      default: ""
    },
    label: {
      required: false,
      type: String,
      default: ""
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    shouldcache: {
      required: false,
      type: Boolean,
      default: false
    },
    additionalLabelClasses: {
      required: false,
      type: String,
      default: ""
    },
    defaultvalue: {
      required: false,
      type: Boolean,
      default: false
    },
    error: {
      required: false,
      type: String,
      default: ""
    },
    serverError: {
      required: false,
      type: String,
      default: ""
    },
    help: {
      required: false,
      type: String,
      default: ""
    },
    prefixId: {
      required: false,
      type: String,
      default: "wdw-form-attr"
    },
    visibleIfResult: {
      required: false,
      type: Boolean,
      default: true
    },
    isPublic: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, context) {
    var _toRefs = toRefs(props),
        name = _toRefs.name,
        code = _toRefs.code,
        label = _toRefs.label,
        required = _toRefs.required,
        defaultvalue = _toRefs.defaultvalue,
        shouldcache = _toRefs.shouldcache,
        error = _toRefs.error,
        serverError = _toRefs.serverError,
        additionalLabelClasses = _toRefs.additionalLabelClasses,
        isPublic = _toRefs.isPublic,
        prefixId = _toRefs.prefixId,
        disabled = _toRefs.disabled;

    var checkboxinput = ref(null);

    var _useToggler = useToggler(),
        shouldShowHelp = _useToggler.toggleValue,
        toggleHelpText = _useToggler.toggle; //+---------------------+
    //|    Other functions  |
    //+---------------------+


    function validate(value) {
      var finalvalue = value ? value : false;
      var returnValue = {
        value: finalvalue,
        valueHuman: finalvalue,
        validated: true,
        name: name.value,
        code: code.value,
        type: "checkbox"
      };

      if (required.value) {
        returnValue.validated = finalvalue;
      }

      if (shouldcache.value) {
        localStorage.setItem(name.value, String(returnValue.value));
      }

      context.emit("validate", returnValue);
      return returnValue.validated ? true : error.value;
    }

    var _useField = useField(name, validate, {
      initialValue: defaultvalue.value
    }),
        errorMessage = _useField.errorMessage,
        value = _useField.value,
        triggerValidation = _useField.validate;

    function handleBlur() {
      triggerValidation();
    }

    function setValue(bool) {
      value.value = bool;
      validate(bool);
    }

    context.expose({
      setValue: setValue,
      name: name,
      value: value
    }); //+---------------------+
    //|    computed()       |
    //+---------------------+

    var hasError = computed(function () {
      return errorMessage.value != undefined;
    });
    var hasServerError = computed(function () {
      return serverError.value != undefined && serverError.value !== "";
    });
    var wrapperClassName = computed(function () {
      return {
        "form-group": true,
        "has-error": hasError.value || hasServerError.value
      };
    });
    var inputClassName = computed(function () {
      return {
        "is-invalid": hasError.value || hasServerError.value
      };
    });
    var labelClassName = computed(function () {
      return additionalLabelClasses.value + " " + (disabled.value ? 'disabled ' : '') + (hasError.value || hasServerError.value ? "text-danger" : "");
    });
    var labelText = computed(function () {
      return label.value + (required.value ? "*" : "") + (isPublic.value ? "" : ' - <span class="text-muted">Diese Daten werden nicht veröffentlicht.</span>');
    });
    var idInput = computed(function () {
      return prefixId.value + "-checkbox-" + name.value;
    });
    var idErrorText = computed(function () {
      return prefixId.value + "-checkbox-" + name.value + "-error";
    }); //+---------------------+
    //|    Lifecycle hooks  |
    //+---------------------+

    onMounted(function () {
      var chbinputref = checkboxinput.value;

      if (chbinputref) {
        chbinputref.oninvalid = chbinputref.setCustomValidity(error.value);
      }
    });
    return {
      // Computed
      hasError: hasError,
      hasServerError: hasServerError,
      wrapperClassName: wrapperClassName,
      labelClassName: labelClassName,
      inputClassName: inputClassName,
      idInput: idInput,
      idErrorText: idErrorText,
      labelText: labelText,
      // References to DOM
      checkboxinput: checkboxinput,
      // Other methods
      toggleHelpText: toggleHelpText,
      handleBlur: handleBlur,
      // Data
      shouldShowHelp: shouldShowHelp,
      errorMessage: errorMessage,
      value: value
    };
  }
};

var _hoisted_1 = {
  class: "checkbox"
};
var _hoisted_2 = ["id", "data-wdw-code", "data-vv-as", "name", "aria-invalid", "aria-describedby", "disabled"];
var _hoisted_3 = ["for", "aria-label"];
var _hoisted_4 = {
  class: "alert alert-info alert-dismissible mb-2 form-info-message",
  role: "alert"
};
var _hoisted_5 = ["id"];
var _hoisted_6 = ["id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return $props.visibleIfResult ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass($setup.wrapperClassName),
    id: "wdw-library-form-control-checkbox"
  }, [createElementVNode("div", _hoisted_1, [withDirectives(createElementVNode("input", {
    id: $setup.idInput,
    ref: "checkboxinput",
    "data-wdw-code": $props.code,
    "data-vv-as": $props.label,
    name: $props.name,
    class: normalizeClass($setup.inputClassName),
    type: "checkbox",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $setup.value = $event;
    }),
    tabindex: "0",
    "aria-invalid": $setup.hasError || $setup.hasServerError,
    "aria-describedby": $setup.idErrorText,
    disabled: $props.disabled,
    onBlur: _cache[1] || (_cache[1] = function () {
      return $setup.handleBlur && $setup.handleBlur.apply($setup, arguments);
    })
  }, null, 42, _hoisted_2), [[vModelCheckbox, $setup.value]]), withDirectives(createElementVNode("label", {
    for: $setup.idInput,
    class: normalizeClass($setup.labelClassName),
    "aria-label": $props.label
  }, null, 10, _hoisted_3), [[_directive_dompurify_html, $setup.labelText]]), $props.help ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "help-trigger",
    title: "Hilfe anzeigen",
    onClick: _cache[2] || (_cache[2] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: "question-circle",
    size: "lg"
  })])) : createCommentVNode("", true), withDirectives(createElementVNode("div", _hoisted_4, [withDirectives(createElementVNode("span", null, null, 512), [[_directive_dompurify_html, $props.help]]), createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "aria-label": "Close",
    onClick: _cache[3] || (_cache[3] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  })], 512), [[vShow, $setup.shouldShowHelp]]), withDirectives(createElementVNode("div", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    class: "text-danger form-error-message"
  }, toDisplayString($props.error), 9, _hoisted_5), [[vShow, $setup.hasError]]), withDirectives(createElementVNode("div", {
    id: $setup.idErrorText,
    class: "text-danger form-error-message",
    "aria-atomic": "true"
  }, toDisplayString($props.serverError), 9, _hoisted_6), [[vShow, $setup.hasServerError]])])], 2)) : createCommentVNode("", true);
}

script.render = render;
script.__scopeId = "data-v-54428932";

export { script as s };
